import { Context } from '~/types/ext/vue'
import { AuthApiUrl } from '~/server/api/route/url'

/**
 * Vueの認証チェック
 */
export default async function requireLogin(ctx: Context): Promise<void> {
  if (!ctx.store.state.authUser) {
    // ログインの場合、ログインページへ戻す
    return ctx.redirect('/auth/login')
  }
  if (process.server) {
    return
  }
  // clientの認証チェック、sessionが有効かチェックする
  try {
    return await ctx.$axios.get(AuthApiUrl.STATUS)
  } catch (e) {
    console.error(AuthApiUrl.STATUS, e) // eslint-disable-line no-console
    ctx.redirect('/auth/login')
  }
}
